import type { ReactNode, ReactElement } from 'react';

import { useRegistry } from '../api/planning-hooks';
import type { RegistryDocument } from '../api/types';
import { ErrorState, Spinner } from './ui';

interface RegistryGateProps {
  /** Spinner label naming the thing being loaded ("Загрузка реестра…"). */
  label: string;
  children: (registry: RegistryDocument) => ReactNode;
}

/**
 * The three mandatory data states around the registry query (STYLEGUIDE §6):
 * loading → spinner naming the resource, error → the API's own message + Retry,
 * otherwise → render with the document. While a mutation refetches, the
 * previous document stays on screen (`placeholderData`), so no flash.
 */
export function RegistryGate({ label, children }: RegistryGateProps): ReactElement {
  const { data, isPending, error, refetch } = useRegistry();

  if (!data && isPending) return <Spinner label={label} />;
  if (!data) {
    const message =
      error instanceof Error
        ? error.message
        : 'Реестр недоступен — вероятно, API ещё не развёрнут (Wave 4).';
    return <ErrorState message={message} onRetry={() => void refetch()} />;
  }
  return <>{children(data)}</>;
}
